import * as React from 'react';
import { scrollToElement } from 'telia-front-react';
import { resolvePrices } from './TvComparisonPriceUtil';
const DEFAULT_VISIBLE_SERVICES_COUNT = 10;
export const createServicesGroup = ({ services, viewerSlotsAmount, translate, isAllShown, filterActions, shownItemsCount, }) => {
    const visibleServicesCount = shownItemsCount || DEFAULT_VISIBLE_SERVICES_COUNT;
    const shownServices = isAllShown ? services : services.slice(0, visibleServicesCount - viewerSlotsAmount);
    return {
        title: `${translate('tvcomparison.services')}`,
        services: shownServices,
        count: services.length + viewerSlotsAmount,
        viewAllButton: services.length + viewerSlotsAmount > visibleServicesCount && {
            text: isAllShown
                ? translate('tvcomparison.showLess.label')
                : `${translate('tvcomparison.showAll.label')} (+${services.length + viewerSlotsAmount - visibleServicesCount})`,
            size: 'small',
            variant: 'secondary',
            onClick: async (event) => {
                await filterActions.toggleAllServicesShown(event);
                isAllShown && scrollToElement(shownServices[0].id);
            },
        },
    };
};
export const mapAdditionalServices = (services, commonProps) => {
    return services === null || services === void 0 ? void 0 : services.map((service) => ({
        id: `additional-service-${service.productOfferingCode}`,
        icon: `#${commonProps.getIcon(service.productOfferingCode)}`,
        title: `${commonProps.translate(`tvcomparison.services.${service.productOfferingCode}.label`)}`,
        description: service.description ? (React.createElement("div", null,
            React.createElement("p", null, service.description),
            commonProps.translate(`tvcomparison.services.${service.productOfferingCode}.learnMoreHtmlLink`))) : (commonProps.translate(`tvcomparison.services.${service.productOfferingCode}.descriptionWithHtml`)),
        packetPrices: resolvePrices(service.prices, service.includedInPackage, commonProps, undefined, commonProps.translate(`tvcomparison.services.${service.productOfferingCode}.label`), 'additional-service').reverse(),
        channelIds: service.channelIds,
    }));
};
export const filterServices = (services, selectedServices) => {
    return services.filter((service) => selectedServices.some((selectedService) => service.productOfferingCode.includes(selectedService)));
};
